import {
  AccessControlConfig,
  AccessibleEntity,
  BuyerCapabilities,
  MultiBuyerCompany,
  MultiBuyerRole,
} from '../interfaces/multi-buyer-company.interface';

export class AccessConfig implements AccessControlConfig {
  private constructor(
    readonly clientId: number,
    readonly userRole: MultiBuyerRole,
    readonly clientName: MultiBuyerCompany,
    readonly buyerAcssLvls: number,
    readonly multiBuyerCmps: number[],
    readonly capabilities: BuyerCapabilities,
    readonly accessibleEntities: AccessibleEntity[],
    readonly isReady: boolean
  ) {}

  static fromApiResponse(
    accessControlConfig: AccessControlConfig
  ): AccessConfig {
    return new AccessConfig(
      accessControlConfig.clientId,
      accessControlConfig.userRole,
      accessControlConfig.clientName,
      accessControlConfig.buyerAcssLvls,
      accessControlConfig.multiBuyerCmps,
      accessControlConfig.capabilities,
      accessControlConfig.accessibleEntities,
      true
    );
  }

  static default(): AccessConfig {
    return new AccessConfig(
      0,
      'none',
      'none',
      0,
      [0],
      FULL_ACCESS_CAPABILITIES,
      [],
      true
    );
  }

  static uninitialized(): AccessConfig {
    return new AccessConfig(
      0,
      'none',
      'none',
      0,
      [],
      LOCKED_CAPABILITIES,
      [],
      false
    );
  }
}

const FULL_ACCESS_CAPABILITIES: BuyerCapabilities = {
  canSeeMarginAndBank: true,
  canCreateTemplate: true,
  canManageBuyerSettings: true,
  hasAccessToTemplate: true,
  canSeeCustomTemplates: false,
  canManageSupplierSettings: true,
  canSeeSupplierBlends: true,
  canAccessMasterTemplate: false,
  canSeeOperatorProjectManager: false,
  canSeeCrmId: false,
};

const LOCKED_CAPABILITIES: BuyerCapabilities = {
  canSeeMarginAndBank: false,
  canCreateTemplate: false,
  canManageBuyerSettings: false,
  hasAccessToTemplate: false,
  canSeeCustomTemplates: false,
  canManageSupplierSettings: false,
  canSeeSupplierBlends: false,
  canAccessMasterTemplate: false,
  canSeeOperatorProjectManager: false,
  canSeeCrmId: false,
};
